import { render } from "./fundRatings.vue?vue&type=template&id=396864d9&scoped=true"
import script from "./fundRatings.vue?vue&type=script&lang=js"
export * from "./fundRatings.vue?vue&type=script&lang=js"

import "./fundRatings.vue?vue&type=style&index=0&id=396864d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396864d9"]])

export default __exports__